// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css';
import { Lazyload, Toast, Dialog } from 'vant';
import '@/common/css/output.scss'
import '../static/leaflet/leaflet.css'
// 配置缩略图生成
import { toThumbsimg, toMd5 } from './common/js/toThumbsimg.js'
Vue.prototype.toThumbsimg = function (img, width, height, type) {
  return BASEURL + toThumbsimg(img, width, height, type)
}

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

Vue.prototype.toMd5 = toMd5;

Vue.config.productionTip = false
import api from "./http";
Vue.use(api);
Vue.use(Vant)
  .use(Lazyload, {
    lazyComponent: true
  })
Vue.use(Toast)
Vue.use(Dialog)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js